import React from 'react'
import { Box, IconButton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ArrowForwardIos } from '@mui/icons-material'
import Link from '../Link'
import pattern01 from '../../images/pattern-01.png'
import iconCvStar from '../../images/icon-cv-star.png'

export default function NotFindingWhatYouWantTry() {
  const {classes} = useStyles()

  return (
    <Box className={classes.root}>
      <img src={iconCvStar} alt="" />

      <span className={classes.text}>
        Not finding what you want try{' '}
        <Link to="#">Comprehensive Job Search Services</Link>
      </span>

      <IconButton
        color="secondary"
        style={{ backgroundColor: 'white', marginLeft: 'auto' }}
        size="large"
      >
        <ArrowForwardIos />
      </IconButton>

      <img className={classes.bg} src={pattern01} alt="" />
    </Box>
  )
}

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',

    marginLeft: '6%',
    marginRight: '6%',
    padding: 30,
    gap: 15,
    height: 146,
    backgroundColor: '#F7F9FC',
    borderRadius: 24,

    '@media (min-width: 1456px)': {
      marginLeft: 'calc((100% - 91rem)/2 + 5.5rem)',
      marginRight: 'calc((100% - 91rem)/2 + 5.5rem)',
    },
  },

  text: {
    fontSize: 19,
  },

  bg: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: '-25%',
    objectFit: 'cover',
    pointerEvents: 'none',
  },
})
